import { adminHttpClient } from '../../commons/adminHttpClient'
import { UserRoles } from '../../account/userRoles'
import { NamedItem } from '../../../domain/common/namedItem'

export interface InternalUserFoSave {
  id: string
  apps: UserRoles[]
  availableApps: NamedItem[]
}

const getInternalUserForSave = (id: string): Promise<InternalUserFoSave> => {
  return adminHttpClient.get(`/csi/InternalUsers/forSave?companyUserId=${id}`)
}

export default getInternalUserForSave
